import { render } from "./CameraZonesHeader.vue?vue&type=template&id=6dbf2482&ts=true"
import script from "./CameraZonesHeader.vue?vue&type=script&lang=ts"
export * from "./CameraZonesHeader.vue?vue&type=script&lang=ts"

import "./CameraZonesHeader.vue?vue&type=style&index=0&id=6dbf2482&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__